import { AttributesMixin, define, Store, type } from "@type-r/models";
import { getCompanies } from "../../api/company";
import { Connections } from "../../api/connection";
import { getAuthorizationBearer, getPlatformCode } from "../../api/endpoint";
import { ChannelTypes, EncryptionMethodsLookup, FlowTypes, ImportTemplatesLookup, PlatformsLookup, ProductsLookup, StatusType } from "../../api/lookups";
import { SortingImportTemplate } from "../../import-templates/models/get-filtered-import-templates-request";
import { ConnectionsFilters, GetConnectionsRequest } from "./connections-filter";

export interface ConnectionsStore extends AttributesMixin<typeof ConnectionsStore> { }
@define
export class ConnectionsStore extends Store {
  static attributes = {
    flowTypes: FlowTypes,
    connections: Connections,
    channelTypes: ChannelTypes,
    platforms: PlatformsLookup,
    products: ProductsLookup,
    encryptionMethods: EncryptionMethodsLookup,
    importTemplates: ImportTemplatesLookup,
    connectionsFilter: ConnectionsFilters,
    selectedFilterBy: String,
    isActive: Boolean
  }

  async initialize(values?: Partial<this>, options?: any) {
    this.connectionsFilter.flowDirection.set({
      selected: 0,
      options: this.flowTypes.items.map((x) => ({
        value: x.id,
        label: x.name
      }))
    })
    this.connectionsFilter.channel.set({
      selected: 0,
      options: this.channelTypes.items.map((x) => ({
        value: x.id,
        label: x.name
      }))
    })

    this.connectionsFilter.company.set({
      placeholder: 'Company',
      selected: [],
      getItems: getCompanies
    })
  }

  mapToQuery = (skip: number = 0, take: number = 30) => {
    return {
      quickSearch: this.connectionsFilter.filterAll && this.connectionsFilter.filterAll.length > 2 ? this.connectionsFilter.filterAll : null,
      companyIds: Array.from(new Set(this.connectionsFilter.company.selected as any)),
      channelType: this.connectionsFilter.channel.selected as any,
      flowDirection: this.connectionsFilter.flowDirection.selected as any,
      connectionId: this.connectionsFilter.connectionId.value as any,
      isActive: this.isActive ? true : null as any,
      sortBy: SortingImportTemplate[this.connectionsFilter.sortBy.attr] as any,
      asc: this.connectionsFilter.sortBy.asc,
      skip,
      take
    } as GetConnectionsRequest;
  }

  getFiltered = async (request?: GetConnectionsRequest): Promise<Connections> => {
    let url: string = 'api/v1/ingest/connections';

    const searchParams = new URLSearchParams();
    if (request.companyIds && request.companyIds.length > 0) {
      request.companyIds.map((id: any) => {
        searchParams.append("companyIds", `${id}`);
      });
      searchParams.append("filterType", `1`);
    }
    if (request.flowDirection) {
      searchParams.append("flowTypeId", `${request.flowDirection}`);
      searchParams.append("filterType", `2`);
    }
    if (request.channelType) {
      searchParams.append("channelTypeId", `${request.channelType}`);
      searchParams.append("filterType", `3`);
    }
    if (request.connectionId) {
      searchParams.append("connectionId", `${request.connectionId}`);
      searchParams.append("filterType", `4`);
    }
    if (request.isActive !== null) {
      searchParams.append("isActive", `${request.isActive}`);
    }
    if (request.quickSearch) {
      searchParams.append("quickSearch", `${request.quickSearch}`);
      searchParams.append("filterType", `0`);
    }
    searchParams.append("sortBy", `${request.sortBy}`);
    searchParams.append("asc", `${request.asc}`);
    searchParams.append("skip", `${request.skip}`);
    searchParams.append("take", `${request.take}`);

    const searchParamsURl = searchParams.toString()
    url += `?${searchParamsURl}`
    return (await fetch(url, {
      method: 'GET',
      headers: new Headers({
        "Authorization": getAuthorizationBearer(),
        'X-Platform-Code': getPlatformCode()
      }),
    })).json();
  }
}
